<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/courses']"><img src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <div class="logout">
        <b>Pratibha Sharma</b>
        <a href="javascript:void(0);"><img src="assets/images/admin/power.png"/> </a>
    </div>
</div>

<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead pt-2">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userCouresLatest pb-2">
                    <div class="imgUploadWrap">
                        <span class="userCouresImage" style="background: url(assets/images/demo.png);"></span>
                        <div class="imgUpload">
                            <input type="file" />
                            <span>CHANGE PICTURE</span>
                        </div>
                    </div>
                    <div class="userCouresContent">
                        <h3>Dummy Course Name</h3>
                        <p>
                            <span>32 Modules</span>
                            <span>54 Sub Modules</span>
                            <span>15 Assessment</span>
                        </p>
                        <p>
                            <span>Created by: Pratibha Sharma on 20 Dec, 2021</span>
                        </p>
                        <p>
                            <span>End Date: 27 Feb, 2021</span>
                            <a href="javascript:void(0);" class="btn-link">EXTEND</a>
                        </p> 
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="courseTabs">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    <ul class="customTab">
                        <li><a href="javascript:void(0);" [routerLink]="['/courses_view_courses']">VIEW COURSES</a> </li>
                        <li><a href="javascript:void(0);" [routerLink]="['/courses_view_user']">VIEW USERS</a> </li>
                        <li><a href="javascript:void(0);" [routerLink]="['/courses_details']" class="active">ASSIGN USERS</a> </li>
                        <li><a href="javascript:void(0);" [routerLink]="['/user_edit']">DUPLICATE</a> </li>
                        <li class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']">DEACTIVATE</a> </li>
                    </ul>
            </div>
            </div>
        </div>
    </div>
    
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-4">
        <h2>Assign Courses</h2>
        <p>Select 1 or more courses from the list to assign to this user. </p>
    </div>
    <div class="col-12 col-md-4">
        <div class="filterWrap">
            <div class="searchWrap mr-0">
                <input type="text" placeholder="Search Users">
            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <div class="filterSelect">
            <span>Filter by Organisation:</span>
            <div class="selectCustom">
                <select>
                    <option>All</option>
                    <option>Select 02</option>
                    <option>Select 03</option>
                </select>
            </div>
        </div>
    </div>
        </div>
    </div>


    <div class="tableWrap">
        <table>
            <thead>
                <tr>
                    <th>
                    <div class="customCheck">
                        <mat-checkbox></mat-checkbox>
                    </div>
                    </th>
                    <th><div class="sort"><b></b> Users</div></th>
                    <th>Email ID</th>
                    <th>Phone Number</th>
                    <th>Organisation</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <div class="customCheck">
                            <mat-checkbox></mat-checkbox>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <span>Rajeev Srivastava </span>
                            <b>Created on 3 Feb, 20211</b>
                        </div>
                    </td>
                    <td>
                        rajeevsrivastava@gmail.com
                    </td>
                    <td>+91 97465 73721</td>
                    <td>Central Railway Zone</td>
                 </tr>
                 <tr>
                    <td>
                        <div class="customCheck">
                            <mat-checkbox></mat-checkbox>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <span>Rajeev Srivastava </span>
                            <b>Created on 3 Feb, 20211</b>
                        </div>
                    </td>
                    <td>
                        rajeevsrivastava@gmail.com
                    </td>
                    <td>+91 97465 73721</td>
                    <td>Central Railway Zone</td>
                 </tr>
                 <tr>
                    <td>
                        <div class="customCheck">
                            <mat-checkbox></mat-checkbox>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <span>Rajeev Srivastava </span>
                            <b>Created on 3 Feb, 20211</b>
                        </div>
                    </td>
                    <td>
                        rajeevsrivastava@gmail.com
                    </td>
                    <td>+91 97465 73721</td>
                    <td>Central Railway Zone</td>
                 </tr>
                 <tr>
                    <td>
                        <div class="customCheck">
                            <mat-checkbox></mat-checkbox>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <span>Rajeev Srivastava </span>
                            <b>Created on 3 Feb, 20211</b>
                        </div>
                    </td>
                    <td>
                        rajeevsrivastava@gmail.com
                    </td>
                    <td>+91 97465 73721</td>
                    <td>Central Railway Zone</td>
                 </tr>
                 <tr>
                    <td>
                        <div class="customCheck">
                            <mat-checkbox></mat-checkbox>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <span>Rajeev Srivastava </span>
                            <b>Created on 3 Feb, 20211</b>
                        </div>
                    </td>
                    <td>
                        rajeevsrivastava@gmail.com
                    </td>
                    <td>+91 97465 73721</td>
                    <td>Central Railway Zone</td>
                 </tr>
             
             </tbody>
        </table>

        <div class="text-center">
            <a href="javascript:void(0);" class="btn btn-primary btn-sm">Assign Courses</a>
        </div>
    </div>


</div>